import {
  TruckIcon,
  ShoppingCartIcon,
  WrenchScrewdriverIcon,
  MusicalNoteIcon,
  EllipsisHorizontalIcon,
  MapPinIcon,
  CakeIcon,
  BeakerIcon
} from '@heroicons/react/24/outline'
import ImageWithFallback from '../components/ImageWithFallback'

/**
 * Get the appropriate icon component for an entity category
 */
export const getCategoryIcon = (category) => {
  const categoryMap = {
    'food_truck': TruckIcon,
    'ice_cream': CakeIcon,
    'coffee': BeakerIcon,
    'retail': ShoppingCartIcon,
    'service': WrenchScrewdriverIcon,
    'entertainment': MusicalNoteIcon,
    'other': EllipsisHorizontalIcon,
  }
  
  return categoryMap[category] || MapPinIcon
}

/**
 * Get default color scheme for a category
 */
export const getCategoryColor = (category) => {
  // Use app primary colors for all categories
  return 'from-primary/10 to-primary/20'
}

/**
 * Get icon color for a category
 */
export const getCategoryIconColor = (category) => {
  // Use app primary color for all category icons
  return 'text-primary'
}

/**
 * Component for rendering entity image with fallback
 * Now uses the standardized ImageWithFallback component
 */
export const EntityImage = ({ 
  entity, 
  className = "w-full h-full object-cover",
  iconClassName = "w-24 h-24",
  containerClassName = ""
}) => {
  return (
    <ImageWithFallback
      src={entity?.image_url || entity?.imageUrl}
      alt={entity?.name || 'Entity'}
      className={className}
      category={entity?.category}
      entityName={entity?.name}
      showIconFallback={true}
      iconClassName={iconClassName}
      containerClassName={containerClassName}
    />
  )
}
